import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface Progress {
  label: string;
  value: number;
}

@Component({
  selector: 'cp-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressComponent {
  @Input()
  progress: {
    first: Progress,
    second: Progress,
    third: Progress
  };
}


